import { PropTypes } from 'prop-types';
import React from 'react';

import { Checkbox, CheckedState } from '@ge/components/checkbox';
import { Capability, PermissionScope } from '@ge/models/constants';
import { useAuth } from '@ge/shared/data-hooks';

const CRContractsLockPopUp = ({ value, onModelOpen, checkedRow }) => {
  const { isAuthorized } = useAuth();

  const isAuthorizedToApproveLock = isAuthorized({
    capabilities: [
      {
        capability: Capability.CR_TRACKER_LOCK_PERIOD,
        scopes: [PermissionScope.EDIT],
      },
    ],
  });

  return (
    <Checkbox
      checkState={value?.lock_flag == true ? CheckedState.CHECKED : CheckedState.UNCHECKED}
      disabled={value?.lock_flag == true || !isAuthorizedToApproveLock}
      onChange={() => {
        if (value?.lock_flag == false) {
          checkedRow.current = value;
          onModelOpen();
        }
      }}
    />
  );
};

export default CRContractsLockPopUp;

CRContractsLockPopUp.propTypes = {
  value: PropTypes.object,
  onModelOpen: PropTypes.any,
  checkedRow: PropTypes.any,
};
